<div
  #layoutTopbar
  [style.display]="isVisible ? 'liline-block' : 'none'"
  class="layout-topbar"
>
  <div class="p-d-flex p-ai-center">
    <a class="topbar-icon-button icon-menu" (click)="toggleSideMenu()"></a>
    <img
      src="./assets/images/sigv-library/header-logo.png"
      alt="logo"
      srcset="
        ./assets/images/sigv-library/header-logo@2x.png 2x,
        ./assets/images/sigv-library/header-logo@3x.png 3x
      "
      style="cursor: pointer"
      (click)="goHome()"
    />
  </div>
  <div class="p-d-flex p-ai-center">
    <!-- <a
      class="topbar-icon-button icon-favorite"
      (click)="commonPanel.toggle($event)"
    ></a>
    <a class="topbar-icon-button icon-notice" pBadge value="25"></a> -->
    <button
      type="button"
      class="p-button p-component"
      (click)="portalBtnClick()"
    >
      <p-avatar
        class="p-d-flex"
        image="./assets/images/sigv-library/icon_portal.svg"
        styleClass="ic-portal"
      ></p-avatar>
      <span class="p-ml-2">Portal</span>
    </button>
    <div class="topbar-horizontal-divider"></div>
    <button
      pButton
      type="button"
      [label]="currentLanguageLabel"
      icon="pi pi-angle-down"
      iconPos="right"
      (click)="langPanel.toggle($event)"
    ></button>
    <div class="topbar-horizontal-divider"></div>
    <button
      type="button"
      class="p-button p-component"
      (click)="userInfoPanel.toggle($event)"
    >
      <span>{{ currentUser?.userNo }} {{ currentUser?.userName }}</span>
      <p-avatar
        image="./assets/images/sigv-library/ic-person.png"
        shape="circle"
      ></p-avatar>
    </button>
  </div>
</div>

<p-overlayPanel #commonPanel [appendTo]="layoutTopbar">
  <div class="list topbar-list">
    <div class="list-item">
      collect 01
      <a href="#" class="list-item-link">移除</a>
    </div>
    <div class="list-item">
      collect 02
      <a href="#" class="list-item-link">移除</a>
    </div>
    <div class="list-item">
      collect 03
      <a href="#" class="list-item-link">移除</a>
    </div>
    <div class="list-item">
      collect 04
      <a href="#" class="list-item-link">移除</a>
    </div>
    <div class="list-item">
      collect 05
      <a href="#" class="list-item-link">移除</a>
    </div>
  </div>
  <button pButton type="button" label="Add" class="w-100"></button>
</p-overlayPanel>

<p-overlayPanel #langPanel [appendTo]="layoutTopbar">
  <div class="list topbar-list">
    <div class="list-item" *ngFor="let languageOption of languageOptions">
      <a
        href="#"
        (click)="changeLanguage($event, languageOption); langPanel.hide()"
      >
        {{ languageOption.label }}
      </a>
    </div>
  </div>
</p-overlayPanel>

<p-overlayPanel #userInfoPanel [appendTo]="layoutTopbar">
  <div class="topbar-userinfo">
    <div class="topbar-userinfo-field">
      <div>User No</div>
      <div>{{ currentUser?.userNo }}</div>
    </div>
    <div class="topbar-userinfo-field">
      <div>User Name</div>
      <div>{{ currentUser?.userName }}</div>
    </div>
    <div class="topbar-userinfo-field last">
      <div>Email</div>
      <div>{{ currentUser?.email }}</div>
    </div>
    <ng-container *ngIf="!isAzureADEnable">
      <p-divider></p-divider>
      <button
        pButton
        type="button"
        label="Log Out"
        (click)="logout()"
        class="w-100"
      ></button>
    </ng-container>
  </div>
</p-overlayPanel>
